import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SimpleButton from '@components/SimpleButton';
import Shell from '@shared/containers/Shell';
import FixedHeader from '@components/FixedHeader';
import OptionRowRadio from '@components/OptionRowRadio';
import FormatPrice from '@shared/containers/FormatPrice';
import ShellFooter from '@components/ShellFooter';
import Card from '@components/Card';

import OptionListSubtitle from '../OptionListSubtitle';

const Body = styled.div`
  padding-top: 14px;
  flex-grow: 1;
`;

class ExclusiveOptionsList extends PureComponent {
  constructor(props) {
    super(props);

    const { initialValue } = props;
    const selected = initialValue ? initialValue.options[0].id : null;
    const selectionIsCompleted = !!initialValue;

    this.state = { selected, selectionIsCompleted };
  }

  onSelect = id => () => {
    this.setState({
      selected: id,
      selectionIsCompleted: true,
    });
  };

  onConfirm = () => {
    const { optionGroup, onConfirm } = this.props;
    const { selected, selectionIsCompleted } = this.state;

    if (selectionIsCompleted) {
      onConfirm({
        id: optionGroup.id,
        options: [{ id: selected }],
      });
    }
  };

  render() {
    const { optionGroup, Footer = SimpleButton, onClose } = this.props;
    const { options } = optionGroup;
    const { selected, selectionIsCompleted } = this.state;

    return (
      <Shell
        isModal
        header={<FixedHeader label={optionGroup.name} onClose={onClose} />}
        footer={
          <ShellFooter>
            <Footer
              elementId="product__option__list"
              label="Aceptar"
              color="primary"
              onClick={this.onConfirm}
              disabled={!selectionIsCompleted}
              block
            />
          </ShellFooter>
        }
      >
        <Body>
          <OptionListSubtitle
            quantity={optionGroup.quantity}
            needsToAdd={selected !== null ? 0 : 1}
          />
          <Card direction="column">
            {options.map(x => (
              <FormatPrice key={x.id} value={x.amount}>
                {formattedPrice => (
                  <OptionRowRadio
                    text={x.name}
                    selected={x.id === selected}
                    onClick={this.onSelect(x.id)}
                    rightText={
                      x.amount &&
                      (x.modifiesPrice
                        ? `${formattedPrice}`
                        : `+ ${formattedPrice}`)
                    }
                  />
                )}
              </FormatPrice>
            ))}
          </Card>
        </Body>
      </Shell>
    );
  }
}

ExclusiveOptionsList.propTypes = {
  optionGroup: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    quantity: PropTypes.number,
    options: PropTypes.array,
  }).isRequired,
  initialValue: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  // Joker
  Footer: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export { ExclusiveOptionsList };
export default ExclusiveOptionsList;
